/**
 * 32-bit djb2 hash (ADD variant, over UTF-16 code units) of `text`.
 * Not cryptographically secure — decorative password-gate only.
 */
export function djb2(text: string): number {
  let hash = 5381;
  for (let index = 0; index < text.length; index += 1) {
    const point = Number(text.codePointAt(index));
    hash = ((hash << 5) + hash + point) >>> 0;
  }
  return hash;
}
